module.exports = __webpack_public_path__ + "static/media/info_paciente_icon6.bcbf2b71.svg";